import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { InfoComplementField } from '@/components/new-info-complete/types';

@Component({ name: 'SourceOfIncome' })
export default class SourceOfIncome extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private incomeSource: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.incomeSource = this.value;
    }

    this.options = await DictApi.getIncomeSource();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.incomeSource) {
      this.incomeSource = val;
    }
  }

  public onValidator(): boolean {
    if (this.incomeSource === undefined || this.incomeSource === null) {
      this.errorMsg = '请选择收入来源';
      return false;
    }

    return true;
  }

  private onChangeIncomeSource(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field label="收入来源" errorMessage={this.errorMsg}>
        <SelectInput
          v-model={this.incomeSource}
          title="选择收入来源"
          placeholder="选择收入来源"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeIncomeSource}
        />
      </Field>
    );
  }
}
